import { Navigate, NavLink, Route, Routes, useLocation } from "react-router-dom";
import { useAuth } from "./auth";
import { post } from "./api";
import Login from "./pages/Login";
import Customers from "./pages/Customers";
import CustomerLayout from "./pages/CustomerLayout";
import CustomerOverview from "./pages/CustomerOverview";
import CustomerReport from "./pages/CustomerReport";
import CustomerActions from "./pages/CustomerActions";
import CustomerMetrics from "./pages/CustomerMetrics";
import CustomerRevenue from "./pages/CustomerRevenue";
import CustomerBillingPlan from "./pages/CustomerBillingPlan";
import Revenue from "./pages/Revenue";
import Actions from "./pages/Actions";
import Findings from "./pages/Findings";
import ActionDetail from "./pages/ActionDetail";
import Admin from "./pages/Admin";

export default function App() {
  const { me, reload } = useAuth();
  const loc = useLocation();

  // Still asking the server. Rendering the login screen here would flash it
  // at somebody who is already signed in.
  if (me === undefined) return <div className="empty">Loading…</div>;

  if (me === null) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="*"
          element={<Navigate to="/login" replace state={{ from: loc.pathname }} />}
        />
      </Routes>
    );
  }

  const signOut = async () => {
    await post("/api/auth/logout");
    // A full reload rather than clearing state in place: it guarantees no
    // customer data stays in memory after signing out.
    window.location.href = "/login";
  };

  return (
    <>
      <header className="topbar">
        <NavLink to="/" className="brand">
          Sage
        </NavLink>
        <nav>
          <NavLink to="/" end className={({ isActive }) => (isActive ? "on" : "")}>
            Customers
          </NavLink>
          <NavLink to="/findings" className={({ isActive }) => (isActive ? "on" : "")}>
            Findings
          </NavLink>
          <NavLink to="/actions" className={({ isActive }) => (isActive ? "on" : "")}>
            Action items
          </NavLink>
          <NavLink to="/revenue" className={({ isActive }) => (isActive ? "on" : "")}>
            Revenue
          </NavLink>
          {me.user.is_admin && (
            <NavLink to="/admin" className={({ isActive }) => (isActive ? "on" : "")}>
              Admin
            </NavLink>
          )}
        </nav>
        <div className="spacer" />
        <span className="who">
          {me.user.name} · {me.user.role}
        </span>
        <button onClick={signOut}>Sign out</button>
      </header>

      <Routes>
        <Route path="/" element={<Customers />} />
        {/* A layout route: the header and tab bar are fetched and drawn
            once, so switching tabs does not rebuild the report frame. */}
        <Route path="/c/:ref" element={<CustomerLayout />}>
          <Route index element={<CustomerOverview />} />
          <Route path="report" element={<CustomerReport />} />
          <Route path="actions" element={<CustomerActions />} />
          <Route path="metrics" element={<CustomerMetrics />} />
          <Route path="revenue" element={<CustomerRevenue />} />
          <Route path="revenue/plan" element={<CustomerBillingPlan />} />
        </Route>
        <Route path="/findings" element={<Findings />} />
        <Route path="/actions" element={<Actions />} />
        <Route path="/revenue" element={<Revenue />} />
        <Route path="/actions/:id" element={<ActionDetail />} />
        {/* Not merely hidden from the nav: a CSM who types the URL is sent
            away, and the server refuses every admin call regardless. */}
        <Route
          path="/admin/*"
          element={me.user.is_admin ? <Admin /> : <Navigate to="/" replace />}
        />
        <Route path="/login" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <span hidden>{reload.name}</span>
    </>
  );
}
